import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  getUserSalaryGroup,
  getUserSupperAdminHrmibleGroup,
} from "../../services/PermissionGroup";
import { useParams, useNavigate } from "react-router-dom";
// import { NavigationBar } from "../components/MasterLayout/NavigationBar";
// import { Profile } from "../components/Profile/Profile";

export const Authen = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const { role }: any = useParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    let isMounted = true;
    
    const checkPermission = async () => {
      try {
        // รอให้ usergroup โหลดเสร็จ (สำหรับกรณี bookmark)
        let userGroup = sessionStorage.getItem("usergroup");
        let attempts = 0;
        const maxAttempts = 10;
        
        while (!userGroup && attempts < maxAttempts && isMounted) {
          await new Promise(resolve => setTimeout(resolve, 500));
          userGroup = sessionStorage.getItem("usergroup");
          attempts++;
        }
        
        if (!isMounted) return;
        
        if (!userGroup) {
          // ถ้าไม่มี usergroup หลังจากรอแล้ว ให้ redirect กลับไปหน้าแรก
          navigate("/", { replace: true });
          return;
        }
        
        let hasPermission = false;
        
        if (role === "backoffice") {
          hasPermission = await getUserSalaryGroup();
        } else if (role === "superadmin") {
          hasPermission = await getUserSupperAdminHrmibleGroup();
        }
        
        if (!isMounted) return;
        
        if (hasPermission) {
          // ใช้ navigate แทน window.location.href เพื่อหลีกเลี่ยง page reload
          navigate(`/${role}/`, { replace: true });
        } else {
          setIsAdmin(false);
          setSuccess(true);
          setIsChecking(false);
        }
      } catch (error) {
        console.error("Error checking permissions:", error);
        if (isMounted) {
          setIsAdmin(false);
          setSuccess(true);
          setIsChecking(false);
        }
      }
    };
    
    checkPermission();
    
    return () => {
      isMounted = false;
    };
  }, [role, navigate]);
  return (
    <>
      {isChecking ? (
        <div className="loaderpage">
          <div className="loader">
            <div className="spinner"></div>
          </div>
        </div>
      ) : success && !isAdmin ? (
        <Container>
          <Row>
            <Col>
              <div className="page-denied text-center align-middle">
                <img src="../../../images/locked.png" alt="" />
                <h5 className="mt-3">Permission denied.</h5>
                <p>Your are not autherized to perform this page.</p>
              </div>
            </Col>
          </Row>
        </Container>
      ) : (
        <div className="loaderpage">
          <div className="loader">
            <div className="spinner"></div>
          </div>
        </div>
      )}
    </>
  );
};
